import React from 'react';

import './Intro.css'

const Intro = (props) => {

	return (
		<div className="Intro col-md-6">
			<h2>Zorgagenda's</h2>
			<p>Waar besteden zorgprofessionals hun tijd aan? Welk deel hiervan is administratie? Wat voor soort administratie is dit en voor wie wordt er geadministreerd? Om antwoord op deze vragen te kunnen geven, interviewde de denktank (Ont)Regel de Zorg professionals uit zes beroepsgroepen over hun werkweek.</p>
			<p>Deze pagina toont de resultaten van dat onderzoek. Kies een beroepsgroep en zie hieronder hoe een gemiddelde werkweek van deze professionals eruitziet.</p>
		</div>
		)

}

export default Intro;



// WEBPACK FOOTER //
// ./src/components/Intro/Intro.js